module.exports = __webpack_public_path__ + "img/copy.25be9a7f.svg";